import { render, staticRenderFns } from "./BuildElectricityMeter.vue?vue&type=template&id=65bb421a&scoped=true"
import script from "./BuildElectricityMeter.vue?vue&type=script&lang=js"
export * from "./BuildElectricityMeter.vue?vue&type=script&lang=js"
import style0 from "./BuildElectricityMeter.vue?vue&type=style&index=0&id=65bb421a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb421a",
  null
  
)

export default component.exports